import React from 'react';
import { LATEST_PROJECTS } from '../homeData';

const HomeProjects = () => {
  const [featured, ...projects] = LATEST_PROJECTS;

  return (
    <div className="home-projects">
      <article className="home-projects__featured">
        <img src={featured.image} alt={featured.title} />
        <div className="home-projects__featured-overlay" />
        <div className="home-projects__featured-content">
          <span className="home-projects__tag">Featured project</span>
          <h3>{featured.title}</h3>
        </div>
      </article>

      <div className="home-projects__grid">
        {projects.map((project) => (
          <article key={project.title} className="home-projects__card">
            <div className="home-projects__card-media">
              <img src={project.image} alt={project.title} />
            </div>
            <h4>{project.title}</h4>
          </article>
        ))}
      </div>
    </div>
  );
};

export default HomeProjects;
